module.exports = __webpack_public_path__ + "static/media/newsletter-september-2018-food-closet.819e0b99.png";